import 'styles/ImageViewer.less'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames/bind'
import Image from 'components/Gallery/Image'
import * as actions from 'actions'

class ImageViewer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      photo: props.photo,
      isImageLoaded: false
    }
  }

  imageHasLoaded() {
    this.setState({
      isImageLoaded: true
    })
  }

  closeModal() {
    document.body.classList.remove('toggle--overflow')
    this.props.dispatch(actions.token.toggleModal({
      modalIsOpen: false,
      modalContent: null
    }))
  }

  stopPropagation(e) {
    e.stopPropagation()
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      photo: nextProps.photo,
      isImageLoaded: false
    })
  }

  navigateNextPhoto() {
    this.setState({
      photo: this.state.photo.next,
      isImageLoaded: false
    })
  }

  navigatePrevPhoto() {
    this.setState({
      photo: this.state.photo.prev,
      isImageLoaded: false
    })
  }

  arrowNavigatePrevPhoto(e) {
    this.stopPropagation(e)
    this.navigatePrevPhoto()
  }

  arrowNavigateNextPhoto(e) {
    this.stopPropagation(e)
    this.navigateNextPhoto()
  }

  handleKeyDown(e) {
    if (e.keyCode == 37) { // Left arrow
      this.navigatePrevPhoto()
    } else if (e.keyCode == 39) { // Right arrow
      this.navigateNextPhoto()
    } else if (e.keyCode == 27) { // Escape
      this.closeModal()
    }
  }

  componentDidMount() {
    this.refs.imageViewer.focus()
  }

  render() {
    let leftArrowClasses = classNames({'no-show': !this.state.isImageLoaded}, 'image-navigation', 'left')
    let rightArrowClasses = classNames({'no-show': !this.state.isImageLoaded}, 'image-navigation', 'right')

    if (this.state.photo) {
      let className = classNames('full-image',
        {'full-image-vertical': this.state.photo.imgSize.height > this.state.photo.imgSize.width},
        {'full-image-horizontal': this.state.photo.imgSize.height < this.state.photo.imgSize.width},
      )
      return (
        <div ref='imageViewer' tabIndex='666013' className='image-viewer fadein' onClick={this.closeModal.bind(this)} onKeyDown={this.handleKeyDown.bind(this)}>
          <span className={leftArrowClasses} onClick={this.arrowNavigatePrevPhoto.bind(this)}>{'<<'}</span>
          <Image photo={this.state.photo} imageLoadedHandler={this.imageHasLoaded.bind(this)} highRes={true} typeOfLoading={Image.loadType.LOADER} myId={this.state.photo.id} className={className} onClick={this.stopPropagation.bind(this)}/>
          <span className={rightArrowClasses} onClick={this.arrowNavigateNextPhoto.bind(this)}>{'>>'}</span>
        </div>
      )
    } else {
      return (null)
    }
  }
}

ImageViewer.contextTypes = {
}
ImageViewer.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(ImageViewer)



// WEBPACK FOOTER //
// ./src/components/Gallery/ImageViewer.js